import { TreeViewCategory } from '@/types'
import { defineStore } from 'pinia'

interface CategoriesState {
  categories: TreeViewCategory[]
  selectedCategory: TreeViewCategory | undefined
  openCategories: TreeViewCategory[]
  showCategories: boolean
  loading: boolean
}

const initialState = (): CategoriesState => {
  return {
    categories: [],
    selectedCategory: undefined,
    openCategories: [],
    showCategories: true,
    loading: false
  }
}

const useCategories = defineStore('categories', {
  state: () => initialState(),
  actions: {
    setSelectedCategory(category: TreeViewCategory | undefined) {
      this.selectedCategory = category
    },
    setOpenCategories(categories: TreeViewCategory[]) {
      this.openCategories = categories
    },
    setShowCategories(show: boolean) {
      this.showCategories = show
    }
  }
})

export default useCategories
